import React, { useEffect, useState } from 'react';
import { useKpiData } from "utils/samarth-dashboard-context/hooks/useKpiData";
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import WidgetWrapper from '../widget-wrapper/widget-wrapper';
import ChartSkeleton from '../../ui/chart-skeleton/chart-skeleton';
import SingleLineCharts from '../../ui/SinglelineCharts/singlelineCharts';
import SingleTabTable from '../../ui/SingleTabTable';
import styles from '../maiWidgets/mai-widget.module.css';

export default function OSAWidget() {
  const { state } = useSamarthDashboardContext();
  const globalViewMode = state.viewMode.globalViewMode;
  const chartData = state.dashboardData.osaData;
  const loader = state.dashboardData.isLoading.osaData;

  const { filters } = useKpiData();
  const [isOn, setIsOn] = useState(false);
  const [currentTDPData, setCurrentTDPData] = useState([]);

  const handleToggle = () => setIsOn(!isOn);

  useEffect(() => {
    if (!Array.isArray(chartData)) {
      setCurrentTDPData([]);
      return;
    }

    const match = chartData.find((data) => data.label === filters.currentTDP);

    setCurrentTDPData(
      filters.actionFilters?.length
        ? match?.data || []
        : chartData
    );
  }, [filters.currentTDP, chartData, filters.actionFilters , isOn]);

  return (
    <WidgetWrapper
      title="OSA"
      isTableView={globalViewMode === 'table'}
      setIsDialogOpen={handleToggle}
      isDialogOpen={isOn}
      infoText="OSA measures the % of products that are buyable on-shelf to the total expected listings for retail channel."
    >
      {loader ? (
        <div style={{ width: '100%', height: '100%' }}>
          <ChartSkeleton isOn={false} />
        </div>
      ) : (
        <div style={{ height: '100%' }}>
          {globalViewMode === 'graph' ? (
            <SingleLineCharts
              data={isOn ? currentTDPData : currentTDPData.slice(0, 4)}
              dataKey="label"
              isExpansionNeeded={!!filters.actionFilters}
            />
          ) : (
            <SingleTabTable
              data={
                filters.actionFilters?.length
                  ? chartData[chartData.length - 1]?.data || []
                  : currentTDPData
              }
              keys={['label', 'value']}
              colorLogic={(value) => {
                if (value >= 60) return styles.textGreen;
                if (value >= 50) return styles.textBlue;
                if (value >= 30) return styles.textYellow;
                return styles.textRed;
              }}
            />
          )}
        </div>
      )}
    </WidgetWrapper>
  );
}
